<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='paginationConfig'
      methods-data='get_coupon_list'
      params>
      <div>
       <span class='left-table'>
           <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>新增</el-button>
        </span>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>刷新</el-button>
        </span>
      </div>
    </icare-table>
    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='50%' @closed='closeDialog'>
      <el-form label-width='120px' ref='form' :rules='rules' :model='form'>

        <el-form-item label='优惠券类型' prop='type'>
          <el-radio-group v-model='form.type'>
            <el-radio label='CASH'>现金券</el-radio>
            <el-radio label='DISCOUNT'>折扣券</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label='有效期类型' prop='date_type'>
          <el-radio-group v-model='form.date_type'>
            <el-radio label='day'>按天数</el-radio>
            <el-radio label='time'>按时间范围</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label='优惠券数量' prop='num'>
          <el-input-number t v-model='form.num' placeholder='请输入优惠券数量' style='width: 30%'></el-input-number> 张
        </el-form-item>

        <div v-if="form.date_type=='time'">

          <el-form-item label='优惠券有效时间'>
            <el-date-picker
              v-model='findDateTime'
              type='datetimerange'
              align='right'
              start-placeholder='开始时间'
              end-placeholder='结束时间'
              format='yyyy-MM-dd HH:mm:ss'
              value-format='yyyy-MM-dd HH:mm:ss'
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-if="form.date_type=='day'">
        <el-form-item label='优惠券有效天数' prop='day'>
          <el-input-number t v-model='form.day' placeholder='请输入优惠券有效天数' style='width: 30%'></el-input-number>
        </el-form-item>
        </div>

        <el-form-item label='优惠券面值' prop='value' v-if='form.type=="CASH"'>
          <el-input-number t v-model='form.value' :precision="2" placeholder='请输入优惠券优惠券面值' style='width: 30%'></el-input-number> <span > 元</span>
        </el-form-item>

        <el-form-item label='优惠券面值' prop='value' v-if='form.type=="DISCOUNT"'>
          <el-input-number t v-model='form.value' :precision="1" placeholder='请输入优惠券优惠券面值' style='width: 30%'></el-input-number><span > 折</span>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 二维码内容 -->
    <el-dialog :title="'二维码内容:'+ QRCodeIDs[0]+''" :visible.sync='qrcodeVisible' width='40%' @closed='closeQRCodeDialog'>

      <div style='margin-top: 20px;' class='min'>
        <!--存放二维码-->
        <div class='qrcode one' id='qrcode' ref='qrCodeUrl' style='margin-top:20px; '></div>
      </div>

      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeQRCodeDialog'>关 闭</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='downLoadQrCode'>下 载</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'
import QRCode from 'qrcodejs2'


export default {
  name: 'get_coupon_list',
  data() {
    return {
      paginationConfig: {
        order_id: '',
        start_time: '',
        end_time: '',
        payment_status: ''
      },
      findDateTime: [],


      //编辑框信息
      editTip: '',
      editVisible: false,
      isEdit: false,

      //***********设备二维码
      qrcodeVisible: false,
      QRCodeIDs: [],
      QRCodeURL: [],            //存放生成的二维码图片地址

      form: {
        type: 'CASH',
        start_time: '',
        end_time: '',
        date_type: 'day',
        day: 0,
        value: 0,
        id: ''
      },
      rules: {},
      titleConfig: [
        {
          field: 'id',
          title: '优惠券编号',
          visible: true
        },
        {
          field: 'ticket_type',
          title: '优惠券类型',
          visible: true,
          fuc: val => {
            return val == 'CASH' ? '<div style="color:#67C23A"><i class="el-icon-coin"></i>现金券</div>' : '<div style="color:#409EFF"><i class="el-icon-discount"></i>折扣券</div>'
          }
        },
        {
          field: 'value',
          title: '优惠券面值',
          visible: true,
          fuc: function(title, item, row) {
            if (row.ticket_type == 'CASH') {
              return '<div>' + (parseInt(row.value) / 100).toFixed(2) + ' 元</div>'
            } else {
              return '<div>' + (parseFloat(row.value/10)).toFixed(1) + ' 折</div>'
            }
          }
        },
        // {
        //   field: 'condition',
        //   title: '使用条件',
        //   visible: true,
        //   fuc: val => {
        //     return val
        //   }
        // },
        {
          field: 'start_time',
          title: '有效开始时间',
          visible: true
        },
        {
          field: 'end_time',
          title: '有效结束时间',
          visible: true
        },
        // {
        //   field: 'uid',
        //   title: '领取用户',
        //   visible: true,
        //   fuc: val => {
        //     return val == 0 ? '-' : val
        //   }
        // },

        {
          field: 'day',
          title: '有效天数',
          visible: true,
          fuc: val => {
            return val == 0 ? '-' : '有效期 '+ val+' 天'
          }
        },
        {
          field: 'grant_time',
          title: '领取时间',
          visible: true
        },
        {
          field: 'is_use',
          title: '使用状态',
          visible: true,
          fuc: val => {
            return val == 1 ? '<div style="color:#67C23A">已使用</div>' : '<div style="color:#E6A23C">未使用</div>'
          }
        },

        {
          field: 'create_time',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 80,
          option: true,
          children: [
            {
              title: '二维码',
              icon: 'el-icon-s-ticket',
              fuc: this.createQRCode
            }
          ]
        }
      ],
      tableParams: {
        order_id: null
      },

      formLabelWidth: '120px',
      offset: 10,
      analyseVisible: false,
      row: {}
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.order_id = this.$route.query.order_id
    this.paginationConfig.order_id = this.$route.query.order_id
  },
  mounted() {
  },
  methods: {

    find() {
      this.$refs.table.refresh()
    },

    statusSelect(v) {
      this.paginationConfig.payment_status = v
    },

    //弹出编辑(新增)对话框
    showAdd() {
      this.isEdit = false
      this.editVisible = true
      this.editTip = '新增信息'
      this.findDateTime=null

      this.form = {
        num:1,
        type: 'CASH',
        start_time: '',
        end_time: '',
        date_type: 'day',
        day: 1,
        value: 1,
        id: ''
      }
    },

    //弹出编辑(新增)对话框
    showEdit(row) {
      this.isEdit = true
      this.editTip = '编辑信息'
      this.editVisible = true
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.dialogType = 0
      this.form = {}
    },
    save() {

      let _this = this
      this.$refs.form.validate(valid => {
        if (valid) {

         if(_this.form.type=="DISCOUNT"&&_this.form.value>10){
           this.$message.warning('优惠券面值不能大于10')
           return
         }

          var form = Object.assign({},_this.form)
          if(_this.form.type=="DISCOUNT"){
            form.value=form.value*10
          }else{
            form.value=form.value*100
          }
          if(_this.form.date_type=="time"){
            form.day=0
          }
          if (_this.findDateTime != null && _this.findDateTime.length === 2) {
            form.start_time = _this.findDateTime[0]
            form.end_time = _this.findDateTime[1]
          }
          gateway({
            func: _this.isEdit == true ? '_' : 'set_create_coupon',
            params: JSON.stringify(form)
          }).then(res => {
            if (res.code === 0) {
              if (this.isEdit) {
                this.$message.success('编辑成功')
              } else {
                this.$message.success('新增成功')
              }
              this.closeDialog()
              this.$refs.table.refresh()
            } else {
              this.$message.warning(res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    // createQRCode(row) {
    //
    //   this.base64QRCode = ''
    //   this.qrCodeTip = row.id
    //   this.createQRCodeVisible = true
    //
    //
    //
    //
    //
    //   var scene = row.id+'.'+row.ticket_type+'.' +row.value
    //     let str = JSON.stringify({
    //     scene: scene,
    //     page: 'pages/consumer/about/about'
    //   })
    //
    //   gateway({
    //     func: 'mini_program_qr',
    //     params: str
    //   }).then((data) => {
    //     if (data != null && data.code == 0) {
    //       if( data.result!=null&& data.result.length>0){
    //         this.showDownQRCode=true
    //         this.base64QRCode = 'data:image/jpg;base64,' + data.result
    //       }
    //     }
    //   })
    // },

    //*************************************************************************************
    //***************************************************设备二维码*************************
    //*************************************************************************************
    //关闭对话框
    closeQRCodeDialog() {
      this.qrcodeVisible = false
    },
    createQRCode(row) {
      this.qrcodeVisible = true
      setTimeout(() => {
        var scene = row.id+'.'+row.ticket_type+'.' +row.value
        this.QRCodeIDs = []
        this.QRCodeIDs.push(this.$global.URL.coupon + scene)
        this.createQrCode()
      }, 1000)
    },
    // 生成二维码
    createQrCode() {
      document.querySelector('.qrcode').innerHTML = ''  // 清空div中的二维码图片
      this.QRCodeIDs.forEach((each) => {                       // 循环创建二维码
        new QRCode(this.$refs.qrCodeUrl, {             // 将创建好的二维码图片放在div中
          text: each,                                  // 需要转换为二维码的内容
          width: 500,
          height: 500,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    downLoadQrCode() {
      var img = document.querySelectorAll('.qrcode img')
      for (var i = 0; i < img.length; i++) {
        var url = img[i].src
        var a = document.createElement('a')
        var event = new MouseEvent('click') // 创建一个单击事件
        a.href = url
        a.download = this.QRCodeIDs[i] + '.png'// 图片名称
        a.dispatchEvent(event) // 触发a的单击事件
      }
    },

  }
}
</script>

<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}
</style>
